import type { PageVariant } from "./regional/market";

export function componentPagePath(id: string, variant: PageVariant): string {
  const base = `/component/${encodeURIComponent(id)}/`;
  return variant === "awg" ? `${base}?units=imperial` : base;
}

/** Units are a display preference on one component document. */
export function componentPageVariantFromSearch(
  search: string,
  fallback: PageVariant = "metric",
): PageVariant {
  const units = new URLSearchParams(search).get("units");
  return units === "imperial" ? "awg" : units === "metric" ? "metric" : fallback;
}

/** Resolve a component detail URL without importing the catalog or engine. */
export function matchComponentPagePath(
  pathname: string,
): { id: string; variant: PageVariant } | null {
  const match = /^\/component\/([^/]+?)(?:\/(awg))?\/?$/.exec(pathname);
  if (!match) return null;
  const variant: PageVariant = match[2] === "awg" ? "awg" : "metric";
  try {
    return { id: decodeURIComponent(match[1]), variant };
  } catch {
    return null;
  }
}
